import React, { Suspense } from "react";
import "./assets/css/tailwind.output.css";
import App from "./App";
import ThemedSuspense from "./components/ThemedSuspense";
import { Windmill } from "@windmill/react-ui";
import windmillTheme from "./windmillTheme";
import { createRoot } from "react-dom/client";
import { AuthContextProvider } from "./context/AuthContext";
import { SidebarProvider } from "./context/SidebarContext";
import "./index.css"
import "./assets/styles/style.css"
import "./assets/styles/common.css"


const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <>
    <SidebarProvider>
      <AuthContextProvider>
        <Suspense fallback={<ThemedSuspense />}>
          <Windmill usePreferences theme={windmillTheme}>
            <App />
          </Windmill>
        </Suspense>
      </AuthContextProvider>
    </SidebarProvider>
  </>
);
